import Auth0Lock from 'auth0-lock';

import { loginServices } from '../../graphql/serviceAuthentication'
import { logoutAfterLoginFailure } from '../../utils/authUtils'

// Initialize the lock widget
const lock = new Auth0Lock(
  process.env.REACT_APP_AUTH0_CLIENT_ID,
  process.env.REACT_APP_AUTH0_DOMAIN,
  {
    auth: {
      redirect: false,
      responseType: 'token id_token', // Return the id token (jwt) in the auth response
    },

    languageDictionary: { title: 'ICON Platform' },
    theme: {
      logo: '../icon_home_logo.png',
      primaryColor: 'slategrey',
    },
    autoclose: false,
  },
);

// Listen for the authenticated event
lock.authorizedPromise = new Promise(resolve => {
  lock.on('authenticated', async authResult => {
    // Set id token in local storage - this will be used to make authorized calls
    document.cookie = `idToken=${authResult.idToken}`;

    // localStorage.setItem('idToken', authResult.idToken);
    let res
    try {
      res = await loginServices();
    } catch (err) {
      logoutAfterLoginFailure()
    }

    lock.hide();
    if (!res || !res.loginServices || !res.loginServices.status || res.loginServices.status !== "success") {
      logoutAfterLoginFailure(res)
    }
    resolve(authResult.idToken);
  });
});

export default lock;



// WEBPACK FOOTER //
// ./src/components/Auth/lock.js